import { Card, CardContent } from '@mui/material'
import { useEffect } from 'react'
import { FaRegComments } from 'react-icons/fa6'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'
import IconBack from '../components/IconBack'
import { useAuth } from '../context/AuthContext'

const Mensagem = () => {
  const history = useHistory()
  const { validateAccess } = useAuth()

  useEffect(() => {
    validateAccess()
    const userFormat = {
      ...JSON.parse(localStorage.getItem('@sisarma-socio-notifications')),
      mensagem: '7', //* Change the number when a new message is added (CardsInitial too)
    }
    localStorage.setItem(
      '@sisarma-socio-notifications',
      JSON.stringify(userFormat)
    )

    document.title = 'SisarmaApp | Mensagem'
  }, [validateAccess])

  return (
    <section>
      <Card className="relative">
        <div
          className="absolute top-6 right-5 text-xl cursor-pointer"
          onClick={() => history.push('/')}
        >
          <IconBack />
        </div>
        <div className="p-5">
          <div className="flex items-center gap-1">
            <FaRegComments />
            <h1 className="text-lg font-semibold">Mensagem</h1>
          </div>
        </div>
      </Card>
      <Card className="mt-2">
        <CardContent className="space-y-3">
          <div className="sm:p-5 space-y-3">
            <p>
              A renovação do CRAF (Certificado de Registro de Arma de Fogo) para
              CACs em 2026 exige atenção imediata devido a prazos unificados e
              instabilidades sistémicas.
            </p>

            <h2 className="font-bold text-lg">⚠️ Alerta de Prazos Cruciais</h2>

            <p>
              <span className="font-semibold">Vencimento Unificado</span>: Todos
              os CRAFs de armas de CAC emitidos antes do Decreto nº 11.615/2023
              vencem em 21 de julho de 2026.
            </p>
            <p>
              <span className="font-semibold">Prazo Limite para Protocolo</span>
              : Para garantir que a arma permaneça regular durante a análise do
              processo, o pedido de renovação deve ser protocolado na Polícia
              Federal até, no máximo, 21 de junho de 2026 (30 dias antes do
              vencimento).
            </p>
            <p>
              <span className="font-semibold">Segurança Jurídica</span>: Se o
              protocolo for realizado dentro deste prazo de 30 dias de
              antecedência, o CRAF é considerado prorrogado e o proprietário
              permanece regular até a decisão final da PF.
            </p>
          </div>
          {/* <img
            src="/comunicado.jpeg"
            alt="Comunicado"
            className="w-full sm:max-w-lg mx-auto"
          /> */}
        </CardContent>
      </Card>
    </section>
  )
}

export default Mensagem
